// Store pagination constants
export const STORE_LIMIT = 50;

// Index constants
export const FIRST_ELEMENT = 0;

